/**
 * Mode de gestion d'une plateforme — pendant front de
 * Codes.ModesGestionPlateforme côté back : GEREE (la PM principale gouverne)
 * ou ADMINISTREE (l'admin pilote, la PM principale n'est que titulaire).
 */
export type ModeGestion = 'GEREE' | 'ADMINISTREE';

/**
 * LE prédicat du mode Administrée : à utiliser partout à la place d'une
 * comparaison littérale — un mode inconnu ou absent est traité comme Gérée,
 * comme côté back.
 */
export const estAdministree = (modeGestion?: string | null): boolean =>
  modeGestion === 'ADMINISTREE';
